<template>
    <div id="communityRule" data-role="page">
        <!-- content -->
        <div class="communityRule-content" data-position="fixed">
            <div class="detailWrap">
                <div class="detail-h">
                    <h3>公寓大廈規約範本</h3>
                </div>
                <div class="detail-c">
                    <ul class="collapse-ul-list rule-list">
                        <li :id="'Wrap'+rule_ind" v-on:click="openWrap(rule_ind)" v-for="(rule,rule_ind) in Rules" :key="rule_ind">
                            <a class="title">
                                <div class="info">
                                    <h4>{{rule.rule_name}}</h4>
                                </div>
                                <i class="icon-dropdown triggerIcon"></i>
                            </a>
                            <div class="triggerWrap">
                                <ul class="collapse-ul-sublist">
                                    <li><a v-bind:href="'https://storage.googleapis.com/kingnetcare/CHK/committee/rule_template/'+rule.file" target="_blank">詳細全文</a></li>
                                    <li v-for="(list,list_ind) in rule.ruleList" :key="list_ind"><a v-bind:href="'https://storage.googleapis.com/kingnetcare/CHK/committee/rule_template/'+list.file">{{list.rule_name}}</a></li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                    <p class="tips">以內政部最新公告之版本為準{{errmsg}}</p>
                </div>
            </div>
        </div>
        <!-- /content -->
        <!-- footer -->
        <div class="qk-link">
            <div class="qk-link-wrap-col1">
                <a href="https://www.cpami.gov.tw/%E6%9C%80%E6%96%B0%E6%B6%88%E6%81%AF/%E6%B3%95%E8%A6%8F%E5%85%AC%E5%91%8A/10474-%E5%85%AC%E5%AF%93%E5%A4%A7%E5%BB%88%E8%A6%8F%E7%B4%84%E7%AF%84%E6%9C%AC.html">
                    <div><span>資料來源</span></div>
                </a>
            </div>               
        </div>
        <!-- /footer -->
    </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      Rules:[]
    }
  },
  mounted(){ 
    this.GetCommunityRuleList();
  },
  methods:{
      openWrap(e){
          let thisWrap = $("#Wrap"+e);
          thisWrap.hasClass("active") ? thisWrap.removeClass('active') : thisWrap.addClass('active')
      },
      GetCommunityRuleList(){
        this.axios.get(`${process.env.ExternalApi}/api/ExternalControllers/Committee/GetCommitteeCommunityRules`).then((response) => {
            if(response.status == 200){
                this.Rules =  response.data.data 
            }
        })       
      }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/communityRule.vue